module.exports = __webpack_public_path__ + "img/report_dealer.95d90f25.png";